import React from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Contact from './components/Contact';
import Footer from './components/Footer';
import GlobalStyles from './styles/GlobalStyles';
// Removed: // import backgroundVideo from './galaxy.mp4';

function App() {
  return (
    <>
      <GlobalStyles />
      <Header />
      <HeroSection />
      <Projects />
      <Skills />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
